import { env } from "@astro/config";
import { apiClient } from "../client";

/**
 * VideoSDK bootstrap reads. These are BFF-local routes (the BFF signs meeting
 * tokens with the server-held secret), NOT Laravel proxies — so they live at
 * the BFF origin root, outside the /api prefix. Absolute URLs bypass the
 * axios baseURL; the session cookie still rides along via withCredentials.
 */
const bffUrl = (path: string) => new URL(env.VITE_API_BASE_URL).origin + path;

export interface VideosdkTokenResponse {
  token: string;
}

export interface VideosdkRoomResponse {
  roomId: string;
  token: string;
}

export const videosdk = {
  /** Short-lived join token for the signed-in user. */
  token: () => apiClient.post<VideosdkTokenResponse>(bffUrl("/videosdk/token")),

  /**
   * Ensure the meeting room exists and get a join token. Idempotent when
   * called with a customRoomId (e.g. `astro-117`) — VideoSDK returns the
   * same room every time, so both consultation parties independently
   * resolve the same room from the booking id alone.
   */
  createRoom: (customRoomId?: string) =>
    apiClient.post<VideosdkRoomResponse>(bffUrl("/videosdk/room"), customRoomId ? { customRoomId } : {}),
};
